var _v15 = 15; var _sommos_build = '2026-04-11g';
/* =============================================================
   STUDIO SOMMOS — Custom JS
   File: sommos-custom.js
   ============================================================= */

/* -------------------------------------------------------------
   1. Perfume PDP — Remove description truncation on /products/slow
   ------------------------------------------------------------- */
if (window.location.pathname === '/products/slow') {
  document.body.classList.add('sommos-slow-pdp');
  document.addEventListener('DOMContentLoaded', function() {
    var prose = document.querySelector('[data-block-type="description"] .prose-truncate');
    if (prose) {
      prose.style.setProperty('-webkit-line-clamp', 'unset', 'important');
      prose.style.setProperty('overflow', 'visible', 'important');
      prose.style.setProperty('display', 'block', 'important');
    }
    var readMoreBtn = document.querySelector('[data-block-type="description"] .read-more-btn');
    if (readMoreBtn) readMoreBtn.style.setProperty('display', 'none', 'important');
  });
}

/* -------------------------------------------------------------
   2. Cart Drawer — Footer flex fix only
   Express checkout hidden on mobile via CSS (sommos-cart-overrides.css section 16)
   ------------------------------------------------------------- */
(function() {

  function fixCartFooter() {
    var footer = document.querySelector('.cart-drawer__footer');
    if (!footer) return;

    footer.style.setProperty('display', 'flex', 'important');
    footer.style.setProperty('flex-direction', 'column', 'important');
  }

  function init() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    fixCartFooter();
    new MutationObserver(function() {
      fixCartFooter();
    }).observe(drawer, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('cart-drawer:refreshed', fixCartFooter);
  document.addEventListener('cart:change', fixCartFooter);

})();

/* Product tab navigation v1 */
(function () {
  if (!window.location.pathname.startsWith('/products/')) return;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildProductTabs);
  } else {
    buildProductTabs();
  }

  function buildProductTabs() {
    if (window.innerWidth >= 960) return;
    if (window._sommosTabsBuilt) return;
    window._sommosTabsBuilt = true;

    var descBlock = document.querySelector(
      '.product-info__block-item[data-block-type="description"]'
    );
    if (!descBlock) return;

    /* Collect all populated accordion blocks that immediately follow description */
    var tabs = [];
    var descContent = descBlock.querySelector('.prose');
    if (descContent) {
      var descWrapper = document.createElement('div');
      var isSlowPage = window.location.pathname === '/products/slow';
      if (isSlowPage) {
        descWrapper.classList.add('sommos-slow-no-truncate');
      }
      var clonedProse = descContent.cloneNode(true);
      if (isSlowPage) {
        clonedProse.classList.remove('prose-truncate');
      }
      descWrapper.appendChild(clonedProse);

      /* Create a fresh Read more button and bind expand behaviour directly */
      if (descContent.classList.contains('prose-truncate') && !isSlowPage) {
        var newBtn = document.createElement('button');
        newBtn.className = 'read-more-btn';
        newBtn.textContent = 'Read more';

        var lessBtn = document.createElement('button');
        lessBtn.className = 'read-more-btn';
        lessBtn.textContent = 'Read less';
        lessBtn.style.display = 'none';

        newBtn.addEventListener('click', function () {
          clonedProse.classList.remove('prose-truncate');
          newBtn.style.display = 'none';
          lessBtn.style.display = '';
        });

        lessBtn.addEventListener('click', function () {
          clonedProse.classList.add('prose-truncate');
          lessBtn.style.display = 'none';
          newBtn.style.display = '';
        });

        descWrapper.appendChild(newBtn);
        descWrapper.appendChild(lessBtn);
      }

      tabs.push({ label: 'Description', contentEl: descWrapper });
    }

    /* Walk siblings after description and collect accordions in DOM order */
    /* Tab order: Description → Details → The Maker → How To Live With It */
    var allAccordions = [];

    /* Prestige wraps accordions in a .accordion-group div — check both patterns */
    var accordionItems = [];
    var nextSib = descBlock.nextElementSibling;
    if (nextSib && nextSib.classList.contains('accordion-group')) {
      /* Wrapped pattern: all accordions inside a group div */
      accordionItems = Array.from(nextSib.querySelectorAll('.product-info__block-item[data-block-type="accordion"]'));
      /* Hide the group wrapper itself later */
      nextSib.dataset.scommosGroup = 'true';
    } else {
      /* Flat pattern: direct siblings */
      var sibling = nextSib;
      while (sibling && sibling.getAttribute('data-block-type') === 'accordion') {
        accordionItems.push(sibling);
        sibling = sibling.nextElementSibling;
      }
    }

    accordionItems.forEach(function(sibling) {
      var summaryText = sibling.querySelector('.accordion__toggle span:first-child');
      var contentEl = sibling.querySelector('.accordion__content');
      if (summaryText && contentEl && sibling.innerText.trim().length > 0) {
        allAccordions.push({
          label: summaryText.textContent.trim(),
          contentEl: contentEl.cloneNode(true)
        });
      }
    });

    /* Reorder: Description first, then Details, then The Maker, then anything else */
    var orderedLabels = ['Details', 'The Maker', 'How to Live With It'];
    orderedLabels.forEach(function (label) {
      var match = allAccordions.find(function (a) {
        return a.label.toLowerCase() === label.toLowerCase();
      });
      if (match) tabs.push(match);
    });
    /* Catch any additional accordions not in the ordered list */
    allAccordions.forEach(function (a) {
      var inOrdered = orderedLabels.some(function (l) {
        return l.toLowerCase() === a.label.toLowerCase();
      });
      if (!inOrdered) tabs.push(a);
    });

    if (tabs.length < 2) return;

    /* Build wrapper */
    var wrapper = document.createElement('div');
    wrapper.className = 'sommos-tabs-wrapper';

    /* Build tab bar */
    var barOuter = document.createElement('div');
    barOuter.className = 'sommos-tab-bar-outer';

    var bar = document.createElement('div');
    bar.className = 'sommos-tab-bar';
    bar.setAttribute('role', 'tablist');

   /* Fade — only show when tab bar is actually overflowing */
    var fade = document.createElement('div');
    fade.className = 'sommos-tab-fade';
    barOuter.appendChild(fade);

    function updateFade() {
      var overflowing = bar.scrollWidth > bar.clientWidth;
      fade.style.display = overflowing ? '' : 'none';
    }
    updateFade();
    window.addEventListener('resize', updateFade);
    bar.addEventListener('scroll', updateFade);

    /* Build panels container */
    var panelsEl = document.createElement('div');
    panelsEl.className = 'sommos-tab-panels';

    tabs.forEach(function (tab, i) {
      /* Tab button */
      var btn = document.createElement('button');
      btn.className = 'sommos-tab-btn' + (i === 0 ? ' is-active' : '');
      var labelSpan = document.createElement('span');
      labelSpan.className = 'sommos-tab-label';
      labelSpan.textContent = tab.label;
      btn.appendChild(labelSpan);
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      btn.addEventListener('click', function () {
        bar.querySelectorAll('.sommos-tab-btn').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        panelsEl.querySelectorAll('.sommos-tab-panel').forEach(function (p) {
          p.classList.remove('is-active');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        panel.classList.add('is-active');
      });
      bar.appendChild(btn);

      /* Panel */
      var panel = document.createElement('div');
      panel.className = 'sommos-tab-panel' + (i === 0 ? ' is-active' : '');
      panel.setAttribute('role', 'tabpanel');
      panel.appendChild(tab.contentEl);
      panelsEl.appendChild(panel);
    });

    if (tabs.length <= 3) {
      bar.classList.add('is-centered');
    }
    barOuter.insertBefore(bar, barOuter.firstChild);
    wrapper.appendChild(barOuter);
    wrapper.appendChild(panelsEl);

    /* Insert tab wrapper before description block, hide original blocks */
    descBlock.parentNode.insertBefore(wrapper, descBlock);
    descBlock.style.display = 'none';

/* Hide original accordion blocks — handle both wrapped and flat patterns */
    var groupEl = document.querySelector('.product-info__block-group.accordion-group');
    if (groupEl) {
      groupEl.style.display = 'none';
    } else {
      var acc = wrapper.nextElementSibling;
      while (acc && acc.getAttribute('data-block-type') === 'accordion') {
        acc.style.display = 'none';
        acc = acc.nextElementSibling;
      }
    }
  }
})();

/* ============================================================
   BREADCRUMB — persist collection context for mobile nav
   Only injects stored collection if referrer confirms the
   customer actually navigated from that collection
   ============================================================ */
(function() {
  const page = window.location.pathname;

  // On collection pages: store handle and title
  if (page.startsWith('/collections/') && !page.includes('/products/')) {
    const parts = page.split('/').filter(Boolean);
    const handle = parts[1];
    const titleEl = document.querySelector('h1');
    const title = titleEl ? titleEl.textContent.trim() : handle.replace(/-/g, ' ');
    if (handle && handle !== 'all') {
      sessionStorage.setItem('sommos_last_collection', JSON.stringify({ handle, title }));
    }
  }

  // On product pages: inject collection crumb only if referrer matches stored collection
  if (page.includes('/products/')) {
    const bc = document.querySelector('.sommos-breadcrumb__list');
    const hasCollection = bc && bc.querySelector('a[href*="/collections/"]');

    if (bc && !hasCollection) {
      try {
        const stored = JSON.parse(sessionStorage.getItem('sommos_last_collection') || 'null');
        const referrer = document.referrer;

        // Only inject if the customer came from that specific collection
        const cameFromCollection = referrer && stored && 
          referrer.includes('/collections/' + stored.handle);

        if (stored && cameFromCollection) {
          const beforeProductSep = bc.querySelector('.sommos-breadcrumb__sep--before-product');

          const sepBefore = document.createElement('li');
          sepBefore.className = 'sommos-breadcrumb__sep';
          sepBefore.setAttribute('aria-hidden', 'true');
          sepBefore.textContent = '›';

          const colLi = document.createElement('li');
          colLi.className = 'sommos-breadcrumb__item';
          const colA = document.createElement('a');
          colA.href = '/collections/' + stored.handle;
          colA.textContent = stored.title.charAt(0).toUpperCase() + stored.title.slice(1);
          colLi.appendChild(colA);

          const sepAfter = document.createElement('li');
          sepAfter.className = 'sommos-breadcrumb__sep';
          sepAfter.setAttribute('aria-hidden', 'true');
          sepAfter.textContent = '›';

          beforeProductSep.before(sepBefore, colLi, sepAfter);
          beforeProductSep.remove();
        }
      } catch(e) {}
    }
  }
})();

/* ── Desktop PDP: gallery height + three-phase scroll ─────────────────
   Scroll sequence going DOWN:
     1. Thumbnail rail scrolls independently
     2. Once thumbs reach bottom → main image carousel scrolls
     3. Once images reach bottom → page scrolls (pulling right column)
   Scroll sequence going UP:
     1. Main image carousel scrolls up
     2. Once images reach top → thumbnail rail scrolls up
     3. Once thumbs reach top → page scrolls up
   
   Other behaviors:
   - Gallery height = viewport minus nav (gives page enough scroll range)
   - Thumbnail scroller capped to gallery height so it can overflow+scroll
   - Both heights updated on resize
   - Thumbnail safe-sticky kept at top:0 (overrides Prestige inline JS)
   - Page scroll handoff uses window.scrollBy for reliable cross-browser
──────────────────────────────────────────────────────────────────────── */
(function() {
  if (window.innerWidth < 1000) return;
  if (!document.querySelector('product-gallery')) return;

  const NAV_OFFSET = 125;
  const gallery = document.querySelector('product-gallery');
  const rightCol = document.querySelector('safe-sticky.product-info');
  const thumbSafeSticky = document.querySelector('product-gallery safe-sticky');
  const thumbScroller = document.querySelector('product-gallery-navigation.product-gallery__thumbnail-scroller');
  if (!gallery || !rightCol || !thumbSafeSticky) return;

  // Set gallery height to viewport minus nav so the page has enough
  // scroll range to drive the gallery through all images independently.
  // Also cap the thumbnail scroller to the same height so it overflows
  // and can scroll independently when there are many thumbnails.
  function updateGalleryHeight() {
    const h = window.innerHeight - NAV_OFFSET;
    gallery.style.height = h + 'px';
    if (thumbScroller) {
      thumbScroller.style.height = h + 'px';
      thumbScroller.style.overflowY = 'scroll';
    }
  }
  updateGalleryHeight();

  // Re-run on resize
  window.addEventListener('resize', updateGalleryHeight);

  // Keep thumbnail safe-sticky top at 0 — override Prestige inline JS
  thumbSafeSticky.style.setProperty('top', '0px', 'important');
  new MutationObserver(function() {
    thumbSafeSticky.style.setProperty('top', '0px', 'important');
  }).observe(thumbSafeSticky, { attributes: true, attributeFilter: ['style'] });

  // Three-phase wheel handler:
  // DOWN: thumbs → images → page
  // UP:   images → thumbs → page
  gallery.addEventListener('wheel', function(e) {
    const ts = thumbScroller;
    const thumbAtBottom = ts ? ts.scrollTop >= ts.scrollHeight - ts.clientHeight - 1 : true;
    const thumbAtTop = ts ? ts.scrollTop <= 0 : true;
    const imgAtBottom = gallery.scrollTop >= gallery.scrollHeight - gallery.clientHeight - 1;
    const imgAtTop = gallery.scrollTop <= 0;

    e.preventDefault();
    e.stopPropagation();

    if (e.deltaY > 0) {
      // Scrolling down
      if (ts && !thumbAtBottom) {
        // Phase 1: scroll thumbnail rail down
        ts.scrollTop += e.deltaY;
      } else if (!imgAtBottom) {
        // Phase 2: scroll image carousel down
        gallery.scrollTop += e.deltaY;
      } else {
        // Phase 3: hand off to page
        window.scrollBy({ top: e.deltaY, behavior: 'auto' });
      }
    } else {
      // Scrolling up
      if (!imgAtTop) {
        // Phase 1: scroll image carousel up
        gallery.scrollTop += e.deltaY;
      } else if (ts && !thumbAtTop) {
        // Phase 2: scroll thumbnail rail up
        ts.scrollTop += e.deltaY;
      } else {
        // Phase 3: hand off to page
        window.scrollBy({ top: e.deltaY, behavior: 'auto' });
      }
    }
  }, { passive: false, capture: true });

})();

/* ── PDP: Hide top color picker separator when no variants to show ─────
   separator_PyD4Ky sits above the SEO variants color picker.
   separator_Et8GVJ sits directly above Add to Bag — always kept.
   Uses MutationObserver + delay to wait for SEO variants to render.
──────────────────────────────────────────────────────────────────────── */
(function() {
  if (!window.location.pathname.startsWith('/products/')) return;

 function updateVariantSeparator() {
    const seoVariants = document.querySelector('[data-block-id*="seo_variants_variants"]');
    const sepAbove = document.querySelector('[data-block-id="separator_PyD4Ky"]');
    if (!seoVariants || !sepAbove) return;

    if (seoVariants.offsetHeight > 0) {
      // Has variants — show the top separator
      sepAbove.style.setProperty('display', 'block', 'important');
    } else {
      // No variants — keep hidden (CSS default)
      sepAbove.style.removeProperty('display');
    }
  }

  function initWithDelay() {
    // Run immediately
    updateVariantSeparator();
    // Run again after short delay to catch late-rendering SEO variants block
    setTimeout(updateVariantSeparator, 300);
    setTimeout(updateVariantSeparator, 800);

    // Also watch for SEO variants block content changes
    const seoVariants = document.querySelector('[data-block-id*="seo_variants_variants"]');
    if (seoVariants) {
      new MutationObserver(updateVariantSeparator)
        .observe(seoVariants, { childList: true, subtree: true, attributes: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWithDelay);
  } else {
    initWithDelay();
  }
})();

// Zero out margins on any @app block that renders with no visible height
function fixZeroHeightAppBlocks() {
  document.querySelectorAll('[data-block-type="@app"]').forEach(el => {
    if (el.getBoundingClientRect().height === 0) {
      el.style.setProperty('margin-block-start', '0px', 'important');
      el.style.setProperty('margin-block-end', '0px', 'important');
    }
  });
}

document.addEventListener('DOMContentLoaded', fixZeroHeightAppBlocks);
setTimeout(fixZeroHeightAppBlocks, 500);
setTimeout(fixZeroHeightAppBlocks, 1500);